import type { IconProps } from '../types/IconProps.ts';
export const ArrowLeft: IconProps = {
    name: 'ArrowLeft',
    children: [
        `<path d="m12 5-6.65 6.65a.5.5 0 0 0 0 .7L12 19M6 12h13" />`,
    ]
};